module.exports = __webpack_public_path__ + "static/media/S2P4_cascade-testing.8cf3d186.mp3";